import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Simple implementation that returns zero personas until products decide to
 * implement their own or use mhub's. A simple version of setMyActivePersona
 * is provided as a way to facilitate using hard-coded personas by extending this
 */
export class LocalPersonaService {
  constructor(myPersonas = [], personas = [], userHasPreviouslyChosenPersona = false) {
    _defineProperty(this, "_personas", void 0);
    _defineProperty(this, "_myPersonas", void 0);
    _defineProperty(this, "_userHasPreviouslyChosenPersona", void 0);
    this._personas = personas;
    this._myPersonas = myPersonas;
    this._userHasPreviouslyChosenPersona = userHasPreviouslyChosenPersona;
  }
  async getPersonas() {
    return this._personas;
  }
  async getMyPersonas() {
    return {
      personas: this._myPersonas
    };
  }

  // TODO: store in localStorage to persist across refreshes/tabs
  async setMyActivePersona(personaId) {
    let activePersona = undefined;
    this._myPersonas = this._myPersonas.map(p => {
      if (p.personaId === personaId) {
        activePersona = {
          ...p,
          isActive: true
        };
        return activePersona;
      }
      return {
        ...p,
        isActive: false
      };
    });
    if (activePersona === undefined) {
      throw new Error("Failed to activate persona");
    }
    return activePersona;
  }
}
//# sourceMappingURL=LocalPersonaService.js.map
